"use client";

import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

const ProjectTabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex h-20 items-center rounded-md p-2 text-muted-foreground overflow-x-auto scroll-bar-component",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & { bg: string }
>(({ bg, className, ...props }, ref) => {
  let dynamicClass;
  if (bg === "blue") {
    dynamicClass =
      "min-w-[200px] flex items-center justify-center whitespace-nowrap rounded-sm px-2 py-4 text-lg font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-[#3A3E45] data-[state=active]:rounded-[40px] data-[state=active]:text-white data-[state=active]:font-bold data-[state=active]:shadow-sm";
  } else if (bg === "green") {
    dynamicClass =
      "min-w-[200px] flex items-center justify-center whitespace-nowrap rounded-sm px-2 py-4 text-lg font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-impact-green data-[state=active]:rounded-[40px] data-[state=active]:text-black data-[state=active]:font-bold data-[state=active]:shadow-sm";
  } else if (bg === "orange") {
    dynamicClass =
      "min-w-[200px] flex items-center justify-center whitespace-nowrap rounded-sm px-2 py-4 text-lg font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-primary data-[state=active]:rounded-[40px] data-[state=active]:text-black data-[state=active]:font-bold data-[state=active]:shadow-sm";
  }
   else {
    dynamicClass =
      "min-w-[200px] flex items-center justify-center whitespace-nowrap rounded-sm px-2 py-4 text-lg font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-primary data-[state=active]:rounded-[40px] data-[state=active]:text-white data-[state=active]:shadow-sm";
  }
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(dynamicClass, className)}
      {...props}
    />
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { ProjectTabs, TabsList, TabsTrigger, TabsContent };
